var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-drawer",class:`m-drawer--${_vm.position} ${_vm.visible ? 'm-drawer-show' : ''}`},[(_vm.mask)?_c('div',{staticClass:"m-drawer-mask",style:('z-index: ' + _vm.zIndex),on:{"click":_vm.handleMaskClick}}):_vm._e(),_c('div',{staticClass:"m-drawer__content",style:('z-index: ' + _vm.zIndex)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }